
// Product video lightbox
document.body.addEventListener("click", async function (e) {
    const btn = e.target.closest(".mobile-media-carousel__play-icon");
    if (!btn) return;

    const mediaEl = btn.closest("[data-media-type='external_video']");
    const iframe = mediaEl?.querySelector("iframe");

    if (!mediaEl || !iframe) {
        console.warn("External video or iframe not found.");
        return;
    }

    const { PhotoSwipeLightbox, PhotoSwipe } = await import(flu.chunks.photoswipe);

    const iframeHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        padding: 5vw;
        box-sizing: border-box;
      ">
        <div style="
          width: 100%;
          max-width: 960px;
          aspect-ratio: 16 / 9;
        ">
          <iframe 
            src="${iframe.src}"
            style="
              width: 100%;
              height: 100%;
              border: none;
              display: block;
            "
            allowfullscreen
          ></iframe>
        </div>
      </div>
    `;

    const lightbox = new PhotoSwipeLightbox({
        dataSource: [{ html: iframeHTML }],
        pswpModule: PhotoSwipe,
        mainClass: "pswp--product-lightbox",
        closeSVG: window.theme?.icons?.close || "",
        arrowPrev: false,
        arrowNext: false,
        zoom: false,
        counter: false
    });

    lightbox.init();
    lightbox.loadAndOpen(0);
});






